import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { env } from '../lib/env.js';
import { logger } from '../lib/logger.js';

let client: SupabaseClient | null = null;

/**
 * Cliente de Supabase. Devuelve `null` si la configuracion falta o no es
 * valida: la app arranca igualmente en modo solo local, porque nada critico
 * depende de la red.
 *
 * La validacion de forma la hace `lib/env.ts`. Aqui solo se registra el
 * diagnostico, sin exponer nunca el valor de la clave.
 */
export function getSupabase(): SupabaseClient | null {
  if (env.isIncomplete) {
    logger.warn(
      'auth',
      'SUPABASE_NOT_CONFIGURED',
      'Configuracion de Supabase ausente o invalida',
      { problemas: env.problems },
    );
    return null;
  }
  client ??= createClient(env.supabaseUrl, env.supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  });
  return client;
}
